import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getInquiryById } from "../../../../redux/features/inquiries/inquiriesService";
import styles from './index.module.css';
import GridLoader from "react-spinners/GridLoader";

const ViewInquiry = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { isInquiryLoading, inquiry } = useSelector((state) => state.inquiry.inquiryDetails);

    useEffect(() => {
        dispatch(getInquiryById({ id: id }));
    }, [dispatch, id]);

    return (
        <div className={`main-card`}>
            <div className={`main-card-body`}>
                <h1 className={`form-title ${styles.headDiv}`}>
                    Inquiry Details
                </h1>
            </div>
            {isInquiryLoading ?
                <div className={`loader-style`}>
                    <GridLoader color="#1D0C50" />
                </div>
                :
                <>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <tbody className={styles.tbody}>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Name</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.name}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Email Address</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.email}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Phone Number</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.phone_number}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Subject</td>
                                    <td className={styles.tdataColumnTwo} style={{ fontWeight: 'bold' }}>{inquiry?.subject}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Message</td>
                                    <td className={styles.tdataColumnTwo}>{inquiry?.message}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Status</td>
                                    <td className={styles.tdataColumnTwo}> <span className={`status-text-label ${inquiry?.status?.toLowerCase()}`}>{inquiry?.status}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </div>
    )
}

export default ViewInquiry;